<template>

  <v-container fluid style="margin: 0px; padding-top: 0px; width: 100%">
    <v-app-bar light app color="white">
      <v-btn
        v-if="isEditing"
        icon
        @click="$router.back()"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title v-if="!isEditing">Add new creative</v-toolbar-title>
      <v-toolbar-title v-if="isEditing">Edit {{person.name}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!isEditing"
        icon
        @click="$router.back()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-row align="center"
        justify="center">
        <EditPersonForm
          :isEditing="isEditing"
          :person="person"
          @created="$router.back()"
          style="width: 80%; max-width: 800px;"/>
    </v-row>
  </v-container>

</template>

<script>
import EditPersonForm from '../components/EditPersonForm.vue';

export default {
  components: {
    EditPersonForm,
  },
  data() {
    return {
      appState: this.$root.$data.appStore.state,
    };
  },
  computed: {
    isEditing: function () {
      return this.$route.params.id !== undefined;
    },
    person: function () {
      return this.isEditing && this.appState.persons.find((p) => p.id === this.$route.params.id);
    },
  },
  methods: {
  },
};
</script>
